import {createDraftSafeSelector} from '@reduxjs/toolkit';

const selectRetailState = (state) => state.retail;

export const selectRetailDevices = createDraftSafeSelector(selectRetailState, (state) => state.devices);

export const selectRetailLocalDevices = createDraftSafeSelector(selectRetailState, (state) => state.localDevices);

export const selectRetailDeviceBySerialNumber = (serialNumber) =>
    createDraftSafeSelector(selectRetailState, (state) => state.devices?.[serialNumber] || {});

export const selectRetailAuthToken = (codentify) =>
    createDraftSafeSelector(selectRetailState, (state) => state?.authTokens?.[codentify]);

export const selectRetailDeviceByCodentify = (deviceCodentify) =>
    createDraftSafeSelector(
        selectRetailState,
        (state) => Object.values(state.devices || {}).find((device) => device?.codentify === deviceCodentify) || null
    );

export const selectRetailDeviceByUserId = (userId) =>
    createDraftSafeSelector(
        selectRetailState,
        (state) => Object.values(state.devices).find((device) => device?.userId === userId) || {}
    );

export const selectUserRewardsIsLoading = (serialNumber) =>
    createDraftSafeSelector(selectRetailState, (state) => state.devices?.[serialNumber]?.rewards?.isLoading);

export const selectNotEarnedYetRewards = (serialNumber) =>
    createDraftSafeSelector(selectRetailState, (state) => state.devices?.[serialNumber]?.rewards?.not_earned_yet);

export const selectAvailableRewards = (serialNumber) =>
    createDraftSafeSelector(selectRetailState, (state) => state.devices?.[serialNumber]?.rewards?.available);

export const selectAvailableRewardsCount = (serialNumber) =>
    createDraftSafeSelector(selectRetailState, (state) => state.devices?.[serialNumber]?.rewards_summary?.available);

export const selectRedeemedRewards = (serialNumber) =>
    createDraftSafeSelector(selectRetailState, (state) => state.devices?.[serialNumber]?.rewards?.redeemed);

export const selectBadgesForUser = (serialNumber) =>
    createDraftSafeSelector(selectRetailState, (state) => state.badges?.[serialNumber]);

export const selectIsRetailDevicesLoading = createDraftSafeSelector(
    selectRetailState,
    (state) => state.isRetailDevicesLoading
);

export const selectUserIds = createDraftSafeSelector(selectRetailState, (state) =>
    Object.values(state.devices)
        .map((item) => item?.userId)
        .filter((item) => item)
);
